module.exports = __webpack_public_path__ + "img/shareholders_rights.0b45bb89.jpg";